import { chakra, Select, FormLabel } from '@stockx/ui';

export const LocationSelectorDropdown = chakra(Select, {
  baseStyle: {
    borderRadius: 0,
    borderWidth: 0,
    height: 9,
    color: 'neutral.600',
  },
});

export const DropdownFormLabel = chakra(FormLabel, {
  baseStyle: {
    color: 'neutral.500',
    fontSize: 'xs',
    marginBottom: 0,
    paddingLeft: 3,
    paddingTop: 1,
  },
});
